export default __webpack_public_path__ + "static/media/bread_knife.1fdf3b37.svg";